import { RootState } from "../types";

export const postForgotPasswordIsUserExist = (state: RootState) => state.forgotPassword.isUserExist;